export const getLuckingIconList = () => {
  return {
    'lucking-grid-1': false,
    'lucking-grid-2': {
      'twinkle': [
        't1', 't2', 't3', 't4', 't5', 't6', 't7',
        'l1', 'l2', 'l3', 'l4', 'l5', 'l6', 'l7',
        'r1', 'r2', 'r3', 'r4', 'r5', 'r6', 'r7',
        'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7'
      ]
    },
    'lucking-grid-3': {
      'twinkle': [
        'l1', 'l2', 'l3', 'l4', 'l5', 'l6', 'l7', 'l8', 'l9', 'l10',
        'r1', 'r2', 'r3', 'r4', 'r5', 'r6', 'r7', 'r8', 'r9', 'r10'
      ],
      'basics': [
        'bottom', 'bottom-top-b', 'bottom-top-b2', 'bottom-left-b', 'bottom-right-b'
      ]
    },
    'lucking-grid-4': {
      'twinkle': [
        't1', 't2', 't3', 't4', 't5', 't6', 't7', 't8', 't9', 't10', 't11', 't12', 't13', 't14', 't15', 't16', 't17',
        'l1', 'l2', 'l3', 'l4', 'l5', 'l6', 'l7', 'l8', 'l9', 'l10', 'l11', 'l12', 'l13', 'l14', 'l15', 'l16', 'l17',
        'r1', 'r2', 'r3', 'r4', 'r5', 'r6', 'r7', 'r8', 'r9', 'r10', 'r11', 'r12', 'r13', 'r14', 'r15', 'r16', 'r17',
        'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8', 'b9', 'b10', 'b11', 'b12', 'b13', 'b14', 'b15', 'b16', 'b17'
      ]
    },
    'lucking-grid-5': false,
    'lucking-slot-machine-1': {
      'basics': [
        'lb', 'rb'
      ]
    },
    'lucking-slot-machine-2': {
      'basics': [
        'box-t', 't1', 't2', 't3', 't4', 't5', 't6', 't7', 't8', 't9', 't10', 't11',
        'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8', 'b9', 'b10', 'b11',
        'l1', 'l2', 'l3', 'l4', 'r1', 'r2', 'r3', 'r4'
      ]
    }
  }
}

export const getPageSizeStyle = (pageSize) => {
  switch (pageSize) {
    case 2:
      return 'width: 100%; height: auto;'
    default:
      return 'width: 100%; height: 100%;'
  }
}

export const getItemStyle = (obj) => {
  var style = ''
  style += obj.size_type + ': ' + obj.size_value + ';'
  if (obj.position !== 'auto') {
    style += 'position: ' + obj.position + ';'
    style += obj.y_axis_type + ': ' + obj.y_axis_value + ';'
    style += obj.x_axis_type + ': ' + obj.x_axis_value + ';'
  }
  if (obj.margin !== 'margin') {
    style += 'margin: ' + obj.margin + ';'
  }
  if (obj.padding !== 'padding') {
    style += 'padding: ' + obj.padding + ';'
  }
  if (obj.style) {
    style += obj.style
  }
  if (obj.z_index) {
    style += 'z-index: ' + obj.z_index + ';'
  }
  return style
}

export const getSimulatorBodyStyle = (background) => {
  var ret = ''
  if (background.color) {
    ret += 'background-color: #' + background.color + ';'
  }
  if (background.font_color) {
    ret += 'color: #' + background.font_color + ';'
  }
  if (background.image) {
    ret += 'background-image: url(' + background.image + ');'
  }
  if (background.image_repeat) {
    ret += 'background-repeat: ' + background.image_repeat + ';'
  }
  if (background.image_position) {
    ret += 'background-position: ' + background.image_position + ';'
  }
  if (background.image_size) {
    ret += 'background-size: ' + background.image_size + ';'
  }
  return ret
}

export const getSimulatorBodyItem = (obj) => {
  var html = ''
  if (obj.image) {
    html += '<div style="padding-top: ' + obj.top + '; padding-bottom: ' + obj.bottom + '; padding-left: ' + obj.left + '; padding-right: ' + obj.right + ';text-align: ' + obj.image_align + ';">'
    html += '<img src="' + obj.image + '" style="width: ' + obj.image_width + ';">'
    html += '</div>'
  }
  return html
}



// WEBPACK FOOTER //
// ./src/libs/tool.js